import RootReducer from './RootReducer';
import { AppState } from './AppState';
import appInitState from '../../Modules/App/Reducers/AppInitState';
import { courseInstanceInitState } from '../../Modules/CourseInstance/Reducers/CourseInstanceInitState';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import AppConfig from '../AppConfig';
import { directAccessInitState } from '../../Modules/DirectAccess/Reducers/DirectAccessInitState';
import { coursesInitState } from '../../Modules/Courses/Reducers/CoursesInitState';
import { courseInitState } from '../../Modules/Course/Reducers/CourseInitState';
import { materialReducerInitState } from '../../Modules/Material/Reducers/MaterialInitState';
import { configureStore, Store } from '@reduxjs/toolkit';
import { registerInfoVisibleInitialState } from '../../Modules/App/Reducers/RegisterInfoReducer';
import { LearningProgressInitState } from '../../Modules/CourseInstance/Components/LearningProgress/Reducers/LearningProgressReducer';

Sentry.init({
  dsn: AppConfig.SENTRY_DSN,
  ignoreErrors: ['AbortError', 'TypeError: Cancelled'],
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  normalizeDepth: 10,
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const preloadState: AppState = {
  App: appInitState,
  ajaxCallInProgressCount: 0,
  CourseInstance: courseInstanceInitState,
  DirectAccess: directAccessInitState,
  Courses: coursesInitState,
  Course: courseInitState,
  Material: materialReducerInitState,
  RegisterInfo: registerInfoVisibleInitialState,
  LearningProgress: LearningProgressInitState,
};

const store: Store<AppState> = configureStore({
  reducer: RootReducer,
  preloadedState: preloadState,
  enhancers: [sentryReduxEnhancer],
});

export default store;
